export const HEADER_STICKED_HEIGHT = 70;
